import React, { Suspense } from 'react';
import ReactDataGrid from "react-data-grid";
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import Select from 'react-select'
import { Container, Row, Col, DropdownButton, Dropdown } from 'react-bootstrap';
import { AppHeader } from '../AppHeader';

import { userService, dataService, creditCardService, cardsService, genericCodesService } from '../_services';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';



class CreditCardDirectDebit_ extends React.Component {

	constructor(props) {
		super(props);
		let user = userService.getUser()
		let card = cardsService.getCardfromSessionStorage();

		this.state = {
			zCreditUrl: "",
			user: user,
			card: card,
			wizardStep: 1,
			pinpad_flow: false,
			rows: [],
			ddOptions: [],
			ddListRows: [],
			pinpad: '',
			DD_NO: 0
		};

		// if (card !== undefined && (this.state.card === undefined ||
		//     card.ID !== this.state.card.ID)) {
		//     this.setState({ card: card });
		// }


		console.log(props);

		this.direct_debit_columns = [
			{
				key: "DD_NO",
				name: this.props.t('dd_no'),
				width: 60,
				resizable: true
			},
			{
				key: "DD_TYPE",
				name: this.props.t('dd_type'),
				width: 40,
				resizable: true
			},
			{
				key: "BANK",
				name: this.props.t('bank'),
				width: 40,
				resizable: true
			},
			{
				key: "BRANCH_NO",
				name: this.props.t('bank_branch_no'),
				width: 60,
				resizable: true
			},
			{
				key: "ACCOUNT_NO",
				name: this.props.t('bank_account_no'),
				resizable: true
			},
			{
				key: "DD_CC",
				name: this.props.t('cc_no'),
				resizable: true
			}
		];
		//this.onMessageReceived = this.onMessageReceived.bind(this);
		//window.addEventListener("message", this.onMessageReceivedHandler, false);

		this.directDebitList();
	}

	componentDidMount() {
		genericCodesService.getPinpad().then(pinpadObj => {
			this.setState({ pinpad: pinpadObj.pinpad || '' })
		})
	}

	onMessageReceivedHandler = (event) => {

		if (event.data === null) {
			return
		}
		try {
			var data = (typeof event.data) === 'string' ? JSON.parse(event.data) : event.data;
			console.log(data);
			if (data.DD_NO !== null) {
				this.gotoStep3();
			}
		} catch (e) {
			console.log(e);
		}

	}

	directDebitList = () => {
		const user = this.state.user;
		if (user && user.token && this.state.card && this.state.card.ID) {
			dataService.directDebitList(user.token, this.state.card.ID).then((data) => {
				console.log(data)

				this.setState({ ddListRows: data });
				return data;
			})
		}
	}

	directDebitBranches = () => {
		const user = this.state.user;
		const card = this.state.card;
		if (user && user.token && card && card.ID) {
			dataService.directDebitBranches(user.token, this.state.card.ID).then((data) => {
				console.log(data)
				if (data.dd_list === undefined) {
					data["dd_list"] = [];
				}
				data.dd_list.unshift({ DD_NO: null, DD_TYPE: "", DD_CC: "" });
				data.dd_list.forEach((element, index) => {
					data.dd_list[index]["value"] = element["DD_NO"];
					//const langKey = 'dd_type_' + (new String(element["DD_TYPE"])).toLocaleLowerCase();
					const langKey = 'dd_type_' + element["DD_TYPE"].toLocaleLowerCase();
					data.dd_list[index]["label"] = element["DD_NO"] === null ? this.props.t("none") : element["DD_NO"] + ": " + this.props.t(langKey) + (element["DD_CC"] ? ('-' + element["DD_CC"]) : " ");
				});
				this.setState({ rows: data.branches, ddOptions: data.dd_list });
				return data;
			})
		}

	}

	// componentDidMount() {

	// }

	handleCardChanged = (card) => {
		console.log(card)
		const currentCardID = this.state.card?.ID || '-';
		if (card?.ID !== currentCardID) {
			this.setState({
				card: card
			});
			this.directDebitList();
		}
	}


	handlePinpadSelect = (e) => {
		//const payLoadObj = { ...this.state.user };
		this.setState({ pinpad_flow: true });
		creditCardService.pinpadCommitFullTransaction({
			card_id: this.state.card.ID, token: this.state.user.token, item_list: "", item_sum: 1, payments_no: 1, card_full_name: this.state.card.H_FULL_NAME,
			client_url_origin: window.location.origin, item_type: 'cc-dd', payLoadObj: null, paymentType: 'authorize', pinpad: e
		}
		).then((data) => {
			console.log(data)
			this.setState({ pinpad_flow: false });
			if (data.error || !data.success) {
				toast.error(data.message || this.props.t("transaction_not_applyed"));
			} else {
				const [DD_NO] = data;
				this.setState({ DD_NO });
				this.gotoStep2()
			}
		}).catch((error) => {
			console.error('Error:', error);
			this.setState({ pinpad_flow: false });
			toast.error(this.props.t("transaction_not_applyed"));
			return ({ 'error': true, "message": error.toString() });
		});

	}

	getSessionToken = () => {
		creditCardService.createSession({
			card_id: this.state.card.ID, token: this.state.user.token, item_list: "", item_sum: 1, card_full_name: this.state.card.H_FULL_NAME,
			client_url_origin: window.location.origin, item_type: "cc-dd", payLoadObj: null, PaymentType: 'authorize'
		}).then((data) => {
			console.log(data)
			this.setState({ zCreditUrl: data.url });
		}).catch((error) => {
			console.error('Error:', error);
			return ({ 'error': true, "message": error.toString() });
		});
	};

	authorizeCreditCard = (event) => {
		event.preventDefault();

	}


	onGridRowsUpdated = ({ fromRow, toRow, updated }) => {
		this.setState(state => {
			const rows = state.rows.slice();
			for (let i = fromRow; i <= toRow; i++) {
				rows[i] = { ...rows[i], ...updated };
			}
			return { rows };
		});
	};
	onFieldChange = (event, id) => {
		console.log(event);
		let myField = "", index = "", value = "";
		myField = id.split("-")[0];
		index = id.split("-")[1];

		if (event.target) {
			value = event.target.value
		} else {
			value = event["DD_NO"];
		}
		let rows = this.state.rows;
		rows[index][myField] = value;
		rows[index]["dirty"] = 'Y';
		this.setState({ rows: rows });
		console.log(this.state.rows[index]);

	}

	gotoStep1 = (event) => {
		if (event) {
			event.preventDefault()
		}
		this.setState({ wizardStep: 1 });
		this.directDebitList();
	}

	gotoStep2 = (event) => {
		if (event) {
			event.preventDefault()
		}
		this.setState({ wizardStep: 2 });
		if (this.state.zCreditUrl === "" || this.state.zCreditUrl === undefined) {
			this.getSessionToken();
		}
	}
	gotoStep3 = (event) => {
		if (event) {
			event.preventDefault()
		}
		this.setState({ wizardStep: 3 });
		this.directDebitBranches();

	}

	saveDDBranches = (event) => {
		event.preventDefault();
		console.log(this.state.rows);
		dataService.directDebitBranchesSave(this.state.user.token, this.state.card.ID, this.state.rows).then(result => {
			console.log(result);
			toast(this.props.t(result.message));

		});

	}

	getLabel = (DIRECT_DEBIT_SEQ) => {
		let labels = this.state.ddOptions.filter(option => option.value === DIRECT_DEBIT_SEQ);
		if (labels.length === 0)
			return ''
		else
			return labels[0].label;
	}



	render() {
		return (
			<Suspense fallback="loading">
				<Container className="col-md-8 autoCenter">
					<ToastContainer rtl />
					<AppHeader user={this.state.user} onCardChanged={this.handleCardChanged} />
					<Row style={{ 'minHeight': '200px', 'height': '100%', 'width': '100%' }} >
						{this.state.wizardStep === 1 &&
							<Row style={{ 'width': 'inherit' }}>
								<div className="row" style={{ 'width': 'inherit' }}>
									<Link className="headerLink" to="" onClick={event => this.gotoStep2(event)}
									>{this.props.t('define_new_dd')}</Link>
									{this.state.pinpad.length > 0
										&& this.state.user.LOGIN_ROLE === 'U'
										&& <div className="elements-line">
											<DropdownButton
												key={`dropdown-button-drop-down`}
												id={`dropdown-button-drop-down`}
												drop="down"
												variant="primary"
												title={` pinpad `}
												onSelect={this.handlePinpadSelect}
											>
												{
													this.state.pinpad.split(",").map((pinpad_id) => (
														<Dropdown.Item eventKey={pinpad_id}>{pinpad_id}</Dropdown.Item>
													))
												}
											</DropdownButton>
										</div>
									}
									{this.state.ddListRows.length > 0 &&
										< Link className="headerLink" to="" onClick={event => this.gotoStep3(event)}
										>{this.props.t('define_branch_dd_detailes')}</Link>
									}
								</div>
								<div className="row" style={{ 'width': 'inherit' }}>
									{this.state.ddListRows.length > 0 &&
										<ReactDataGrid
											rowKey="DD_NO"
											columns={this.direct_debit_columns}
											rowGetter={i => this.state.ddListRows[i]}
											rowsCount={this.state.ddListRows.length}
										/>
									}
									{this.state.ddListRows.length === 0 &&
										<span>
											{this.props.t('no_dd_for_card')}
										</span>
									}
								</div>
							</Row>
						}

						{this.state.wizardStep === 2 &&
							//this.state.zCreditUrl !== "" &&
							<Row style={{ 'width': 'inherit' }}>

								<div className="row" style={{ 'width': 'inherit' }}>
									<Link className="headerLink" to="" onClick={event => this.gotoStep1(event)}
									>{this.props.t('dd_list_exist')}</Link>
								</div>
								{!this.state.pinpad_flow &&
									<iframe title="get_request_token" style={{ 'height': '100%', 'width': '100%', 'minHeight': '700px', 'borderWidth': '0' }} src={this.state.zCreditUrl} />
								}
								{this.state.pinpad_flow &&
									<div>
										<h4>{this.props.t('dd_created_successfully') + ': ' + this.state.DD_NO} </h4>
										<Link className="headerLink" to="" onClick={event => this.gotoStep3(event)}
										>{this.props.t('define_branch_dd_detailes')}</Link>
									</div>
								}

							</Row>
						}

						{this.state.wizardStep === 3 &&
							<Row style={{ 'width': 'inherit' }}>
								<Row style={{ 'width': 'inherit' }}>
									<Link className="headerLink" to="" onClick={event => this.gotoStep1(event)}
									>{this.props.t('dd_list_exist')}</Link>

									<Link className="headerLink" to="" onClick={event => this.saveDDBranches(event)}
									>{this.props.t('save')}</Link>
								</Row>
								<Row id="branches_header" style={{ 'width': 'inherit' }}>
									<Col className="col-1">
										{this.props.t('branch_code')}
									</Col>
									<Col className="col-4">
										{this.props.t('branch_hname')}
									</Col>
									<Col className="col-4">
										{this.props.t('direct_debit_seq')}
									</Col>
									<Col className={"col-2" + (this.state.user.LOGIN_ROLE === 'C' ? " invisible" : "")}>
										{this.props.t('dd_max_limit')}
									</Col>
								</Row>
								{
									this.state.rows.map((row, index) => {
										console.log("row");
										console.log(row);
										return (
											<Row key={row.BRANCH_CODE} className="branchGrid">
												<Col className="col-1" >
													{row.BRANCH_CODE}
												</Col>
												<Col className="col-4">
													{row.HNAME}
												</Col>
												<Col className="col-4">
													<Select id={"DIRECT_DEBIT_SEQ-" + index} options={this.state.ddOptions} onChange={(selectedOption) => { this.onFieldChange(selectedOption, "DIRECT_DEBIT_SEQ-" + index) }} value={{ 'value': row.DIRECT_DEBIT_SEQ, 'label': this.getLabel(row.DIRECT_DEBIT_SEQ) }} />
												</Col>
												<Col className={"col-2" + (this.state.user.LOGIN_ROLE === 'C' ? " invisible" : "")} >
													<input style={{ 'max-width': '60px' }} id={"DD_MAX_LIMIT-" + index} type="Text" onChange={(event) => { this.onFieldChange(event, "DD_MAX_LIMIT-" + index) }} defaultValue={row.DD_MAX_LIMIT || 0}></input>
												</Col>
											</Row>
										)
									})
								}

							</Row>
						}
					</Row>
				</Container>
			</Suspense >
		);
	}
}


const CreditCardDirectDebit = withTranslation()(CreditCardDirectDebit_);

export { CreditCardDirectDebit, CreditCardDirectDebit_ };

